import React from 'react';

export const LoaderSkeleton = ({ count = 20 }) => {
  const CellLoader = () => (
    <td className="flex-1 py-4 pr-4 pl-2">
      <div className="h-5 animate-pulse bg-gray-200 rounded-md">&nbsp;</div>
    </td>
  );
  return (
    <>
      {new Array(count).fill(0).map((_, id) => (
        <tr key={id} data-testid="skeleton-item" className="my-2">
          {CellLoader()}
          {CellLoader()}
          {CellLoader()}
          {CellLoader()}
          <td className="flex py-[10px] pr-4 pl-2">
            <div className="mr-2 h-[30px] w-[30px] inline-block animate-pulse rounded-full bg-gray-200">
              &nbsp;
            </div>

            <div className="h-5 mt-1 flex-grow animate-pulse bg-gray-200 rounded-md">
              &nbsp;
            </div>
          </td>
          <td className="flex-1 py-[10px] pr-4 pl-2">
            <div className="h-5 w-[calc(100%-40px)] inline-block mt-2 mr-2 animate-pulse bg-gray-200 rounded-md">
              &nbsp;
            </div>
            <div className="h-5 w-8 inline-block mt-2 animate-pulse bg-gray-200 rounded-md">
              &nbsp;
            </div>
          </td>
        </tr>
      ))}
    </>
  );
};
